import { useMojeSouborySeznamContext } from '@gov-nx/module/page';
import { TableHeadBinned } from './TableHeadBinned';
import { TableRowBinned } from './TableRowBinned';

export const TableBinned = () => {
	const { documentsBinned } = useMojeSouborySeznamContext();

	return (
		<div>
			{documentsBinned?.seznam && documentsBinned?.seznam.length > 0 && (
				<TableHeadBinned />
			)}
			<ul className="gov-list--plain">
				{documentsBinned?.seznam?.map((document) => (
					<TableRowBinned
						key={document.id}
						document={document}
					/>
				))}
			</ul>
		</div>
	);
};
